import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { propTypes } from './Divider.types.js';
import styles from './Divider.module.scss.js';

/**
 * Use Divider to comunicate a division between components
 */
var Divider = /** @class */ (function (_super) {
    __extends(Divider, _super);
    function Divider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Divider.prototype.render = function () {
        var _a = this.props, width = _a.width, className = _a.className;
        return (React__default.createElement("hr", __assign({ "data-testid": "divider", className: "\n                    " + styles.Divider + "\n                    " + (className || '') + "\n                " }, (width ? { style: { width: width + "px" } } : {}))));
    };
    Divider.displayName = 'Divider';
    Divider.propTypes = propTypes;
    return Divider;
}(React__default.Component));

export { Divider as default };
